<template>
  <a-button
      type="primary"
      @click="toRevocationAnn" :loading="publishLoading"
      icon="rollback">撤回官网公告
  </a-button>
</template>
<script>

import {AnnounceState} from "@/views/bid/announce/util/AnnounceUtil";

export default {
  name: 'AnnounceRevocation',
  computed: {},
  components: {},
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  created() {
  },
  data() {
    return {
      publishLoading: false,
    }
  },
  methods: {
    //撤回官网公告
    toRevocationAnn() {
      let that = this
      let message = ""
      this.$confirm({
        title: '提示',
        content: '确定要撤回官网的公告吗？',
        onOk() {
          that.revocationAnn()
        }
      })
    },
    //撤回公告
    async revocationAnn() {
      let that = this
      try {
        this.publishLoading = true
        that.$emit('changeAnn', this.publishLoading)
        const data = {
          announceId: this.id,
          state: AnnounceState.REVOCATION
        }
        let res = await that.$http.post('/api/v1/announce/revocationAnnounce', data)
        if (res.code !== 200) {
          that.$message.error(res.msg || '撤回公告失败')
          return
        }
        that.$message.success('撤回公告成功')
        that.$emit('Refresh')
      } catch (e) {
        that.$message.error(e.message)
      } finally {
        that.publishLoading = false
        that.$emit('changeAnn', this.publishLoading)
      }
    },
  }
}
</script>

<style scoped>

</style>

